module.exports = __webpack_public_path__ + "img/no-monthly-team-rating.2614581a.png";